<template>
  <div class="bind_h5">
    <p class="test">
      您正在绑定账户：
      <span>【{{userInfo}}】</span>
    </p>
    <el-button class="btn" type="primary" @click="sureBind">确认绑定</el-button>
  </div>
</template>

<script>
import { GetBindUserInfo } from "@/pages/page1/api/modules/user";
export default {
  metaInfo: { title: "账户绑定 - 多比商城" },
  name: "bindH5",
  data() {
    return {
      userInfo: undefined,
      sign: undefined,
    };
  },
  mounted() {
    let contentWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    let fontSize = (contentWidth * 18) / 375;
    document.documentElement.style.fontSize = fontSize + "px";
    // alert(contentWidth);
    // 扫码后进入的h5页面，后台传参sign，通过sign获取用户信息
    this.sign = this.$route.query.sign;
    // console.log(this.$route.query.sign);
    this.getUserInfo(this.$route.query.sign);
  },
  methods: {
    getUserInfo(sign) {
      let params = {
        sign,
      };
      GetBindUserInfo(params).then((res) => {
        // console.log("获取绑定用户信息", res);
        this.userInfo = res.data[0].userAccount;
      });
    },
    sureBind() {
      let baseUrl = process.env.VUE_APP_BASE_URL;
      location.href =
        baseUrl + "/api/v1/userinfo/UserBindWechat?sign=" + this.sign;
      // this.$router.push({
      //   name:'bindResult',
      //   query:{
      //     state:1,
      //     msg:'成功'
      //   }
      // })
    },
  },
};
</script>

<style lang="less" scoped>
.bind_h5 {
  height: 100%;
  box-sizing: border-box;
  font-size: 0.875rem;
  text-align: center;
  padding-top: 30%;
  .test {
    margin-bottom: 2rem;
    padding: 0 2rem;
    word-wrap: break-word;
  }
  .btn {
    width: 12.25rem;
    letter-spacing: 0.1792rem;
    padding: 0.5rem 1.25rem;
    font-size: 0.875rem;
  }
}
</style>